<script>

import Multiselect from 'vue-multiselect';

/* eslint-disable no-console */

export default {
  components: {
    Multiselect
  },
  data() {
    return {
      passSelectedId: 0,
      passSelected: null,
      selectedId: 0,
      selected: null,
      options: [],
      
    }
  },
  props: {
    id: {
      type: String,
    },
    label: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    },
    first: {
      type: String,
      default: 'general.please-select'
    },
    optionKey: {
      type: String,
      default: 'id'
    },
    prefix: {
      type: String,
      default: ''
    },
    postfix: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: 'name'
    },
    text2: null,
    require: {
      default: false
    },
    auto: {
      default: false,
    },
    list: {},
    value: null,
    disabled: {
      default: false
    },
    editable: {
      default: true
    }
  },
  watch: {
    list: function(val) {
      this.options = val.data;
    },

    selected: function(val) {
      this.$emit('choose', val);
    },

  },
  methods: {
    
    getList: function() {
      if(Object.keys(this.list).length !== 0)  {
        return this.list.data;
      } 
    },
    displayCustom: function(obj) {
      return this.text2 != null ? `${obj[this.text]} - (${obj[this.text2]})` :  `${obj[this.text]}`;
    },
    displayCustomMultiple: function(obj) {
      return `${obj[this.text]}`;
    },

    checkValue() {
      console.log(JSON.stringify(this.selected));
    },

    updateValue: function(event) {
   
      this.value = this.selected;

      this.selectedId = event.id;
      this.$emit('input', event.id);
      this.$emit('change', event);

    },
  },
};
</script>
<template>
  <div class="form-group">
      <b-form-group
        class="mb-3"
        :label="$t(label)"
        :label-for="id"
      >
        <multiselect v-model="selected" @select="($event) => updateValue($event)"
          :custom-label="displayCustomMultiple"
          :placeholder="`${$t(first)} ${$t(label)}`" 
          :label="text" 
          :track-by="text"
          :options="options" :multiple="true"></multiselect>
        
        <i v-show="editable || passSelected == null" style="position: absolute; right: 20px; top: 35px; background-color: white" class='bx bx-chevron-down font-size-24'></i>
        <b-form-invalid-feedback v-show="require" :state="validation">
          <span>{{`${$t('general.please-enter')} ${$t(label)}`}}</span>
        </b-form-invalid-feedback>
        <!-- <b-button @click="checkValue" variant="primary">Submit</b-button> -->
      </b-form-group>
  </div>
</template>